import { render } from "./comp.vue?vue&type=template&id=57a896d2&scoped=true"
import script from "./comp.vue?vue&type=script&lang=js"
export * from "./comp.vue?vue&type=script&lang=js"

import "./comp.vue?vue&type=style&index=0&id=57a896d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-57a896d2"

export default script